import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Breadcrumbs } from '../../AbstractElements'
import { Card, Container, Row, Table } from 'reactstrap'
import { Col, FormLabel } from 'react-bootstrap'
import { useLoader } from '../../_helper/LoaderContext'
import { getInvoiceDetail, getTransactionDetail } from './service/ledger-service'
import Payment from './Payment'
import { useLab } from '../../_helper/PharmacyProvider'
import { formatDoctorDisplayDate } from '../../utils/dateTime/dateFormat'
import { useCurrency } from '../../_helper/currencyContext'
import MyPagination from '../pagination'

export default function ViewDetailLedger() {
    const { id } = useParams()
    const { setLoading } = useLoader();
    const { currentLab } = useLab();
    const [showRecipt, setShowRecipt] = useState(false);
    const [paymentData, setPaymentData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { getCurrencySymbol, convertCurrency, currency } = useCurrency();
    const [trData, setTrData] = useState({})

    const [data, setData] = useState([]);

    useEffect(() => {
        getDetail()
    }, [id, currentPage, entriesPerPage,])

    const getDetail = async () => {
        setLoading(true)
        try {
            const res = await getTransactionDetail(id);
            if (res.data.success == true) {
                setPaymentData(res.data.data.totals);
                setData(res.data.data.payments);
                setTotalEntries(res.data.data.totalPages || 0);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const openMode = async (data) => {
        setLoading(true)
        try {
            const res = await getInvoiceDetail(data.salesId);
            if (res.data.success == true) {
                setShowRecipt(true);
                setTrData(res.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Breadcrumbs mainTitle="Transactions Detail" parent="Home" subParent="Ledger List" title="Transactions Detail" />
            <Container fluid={true}>
                <Row>
                    <Col>
                        {/* <div className="tw-flex tw-flex-wrap tw-gap-4">
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="bg-primary tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalNet?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Net Total</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="bg-success tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalPaid?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Paid</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-red-600 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalDue?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Due</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-cyan-500 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{paymentData.totalTransactions}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Transactions</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-amber-500 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalRefund?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Refund</p>
                                </div>
                            </div>
                        </div> */}
                        <Card >
                            {/* Transaction History Table */}
                            <div className="tw-px-3 tw-py-4">
                                {/* <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                                    <h2 className="tw-text-xl tw-font-semibold tw-text-gray-800">Transaction History</h2>
                                    <div className="tw-text-sm tw-text-gray-600">
                                        Customer Name: <span className="tw-font-medium tw-text-gray-900"></span>
                                    </div>
                                </div> */}

                                <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                                >
                                    <Table className="mb-0 table-center table-bordered table-hover" style={{ tableLayout: "fixed", overflowX: "auto", }}>
                                        <thead>
                                            <tr>
                                                <th className="text-center bg-primary tw-text-center" style={{
                                                    width: "80px"   // 👈 add width only to first column
                                                }}>
                                                    <b>#</b>
                                                </th>
                                                <th className="bg-primary text-white text-left" style={{ width: "150px" }}><b>Transaction Type</b></th>
                                                <th className="bg-primary text-white text-left" style={{ width: "145px" }}><b>Date</b></th>
                                                <th className="bg-primary text-white" style={{ width: "100px" }}><b>Net Total</b></th>
                                                <th className="bg-primary text-white" style={{ width: "92px" }}><b>Credit (+)</b></th>
                                                <th className="bg-primary text-white" style={{ width: "92px" }}><b>Debit (-)</b></th>
                                                <th className="bg-primary text-white" style={{ width: "180px" }}><b>Outstanding Balance</b></th>
                                                <th className="bg-primary text-white" style={{ width: "100px" }}><b>Method</b></th>
                                                {/* <th className="bg-primary text-white" style={{ width: "85px" }}><b>Currency</b></th> */}
                                                <th className="bg-primary text-white" style={{ width: "100px" }}><b>Status</b></th>
                                                <th className="bg-primary text-white text-center" style={{ width: "80px" }}><b>Action</b></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index) => {
                                                const serialNumber = getStartingSerialNumber() + index;
                                                return (
                                                    <tr
                                                        key={item.id}
                                                        className={`tw-border-b tw-border-gray-200 hover:tw-bg-gray-50 ${index % 2 === 0 ? '' : ''
                                                            }`}
                                                    >
                                                        <td className="text-center font-weight-bold">
                                                            {serialNumber}
                                                        </td>
                                                        {/* # */}
                                                        {/* <td className="tw-px-4 tw-py-4 tw-font-medium tw-text-gray-900">
                                                        {index + 1}
                                                    </td> */}

                                                        {/* Transaction Type */}
                                                        <td className="tw-px-4 tw-py-4 ps-2">
                                                            <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-bold text-capitalize bg-primary">
                                                                {item.salesType}
                                                            </span>
                                                        </td>

                                                        {/* Date */}
                                                        <td className="tw-px-4 tw-py-4 tw-text-gray-700">
                                                            <div className="">{formatDoctorDisplayDate(item.createdAt, currentLab) || "-"}</div>
                                                        </td>

                                                        {/* Net Total */}
                                                        <td className="tw-px-4 tw-py-4 tw-font-bold tw-text-gray-900">
                                                            {item.netTotal > 0 ? (
                                                                <>
                                                                    {getCurrencySymbol(item.currency)}{item.netTotal?.toFixed(2)}
                                                                </>
                                                            ) : (
                                                                <>-</>
                                                            )}
                                                        </td>

                                                        {/* Credit (+) */}
                                                        <td className="tw-px-4 tw-py-4 text-success fw-bold">
                                                            {getCurrencySymbol(item.currency)}{item.amount?.toFixed(2)}
                                                        </td>

                                                        {/* Debit (-) */}
                                                        <td className="tw-px-4 tw-py-4 tw-font-bold text-danger">
                                                            {item.credit?.toFixed(2) || "-"}
                                                        </td>

                                                        {/* Outstanding Balance */}
                                                        <td className="tw-px-4 tw-py-4 tw-font-bold tw-text-gray-900">
                                                            {item.currency &&
                                                                item.balances &&
                                                                Object.keys(item.balances).length > 0 &&
                                                                item.balances[item.currency] !== undefined
                                                                ? `${getCurrencySymbol(item.currency)}${Number(item.balances[item.currency]).toFixed(2)}`
                                                                : "0"
                                                            }
                                                        </td>

                                                        {/* Method */}
                                                        <td className="tw-px-4 tw-py-4 tw-capitalize">
                                                            {item.paymentType !== "refund" ? (
                                                                <span className="tw-bg-gray-200 tw-border tw-border-gray-700 px-2 py-1 tw-rounded-lg text-black">
                                                                    {item.paymentType}
                                                                </span>
                                                            ) : (
                                                                <span className="tw-bg-gray-200 tw-border tw-border-gray-700 px-2 py-1 tw-rounded-lg text-black">
                                                                    Cash
                                                                </span>
                                                            )}
                                                            {/* {item.method} */}
                                                        </td>

                                                        {/* Currency */}
                                                        {/* <td className="tw-px-4 tw-py-4 tw-text-gray-700">
                                                            {item.currency}
                                                        </td> */}

                                                        {/* Status */}
                                                        <td className="tw-px-4 tw-py-4">
                                                            {item.isSettled ? (
                                                                <span className="badge bg-success">Settled</span>
                                                            ) : (
                                                                <>
                                                                    {item.isPaid && (
                                                                        <span className="badge bg-primary">Paid</span>
                                                                    )}
                                                                    {item.isPartialPaid && (
                                                                        <span className="badge bg-warning text-dark">Partial Paid</span>
                                                                    )}
                                                                    {item.salesType === 'payment' &&
                                                                        !item.isPaid &&
                                                                        !item.isSettled &&
                                                                        !item.isPartialPaid && (
                                                                            <span className="badge bg-primary">Payment</span>
                                                                        )}
                                                                    {item.salesType === 'refund' &&
                                                                        !item.isPaid &&
                                                                        !item.isSettled &&
                                                                        !item.isPartialPaid && (
                                                                            <span className="badge bg-danger">Refund</span>
                                                                        )}
                                                                </>
                                                            )}
                                                        </td>

                                                        {/* Action - Eye Icon with Tooltip */}
                                                        <td className="tw-px-4 tw-py-4 tw-text-center mt-3">
                                                            {item.rePayment !== true && item.isSettled == false ? (
                                                                <button className='success-action-button me-1' onClick={() => openMode(item)}>
                                                                    <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                                </button>
                                                            ) : (
                                                                <div className="">-</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            )}
                                            {/* <td className="tw-px-4 tw-py-4 text-center">
                                                <div className="">
                                                    <button className='success-action-button me-1'>
                                                        <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                    </button>
                                                </div>
                                            </td> */}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-md-flex align-items-center text-center justify-content-between mt-3">
                                    <div className="show-entries">
                                        <FormLabel>Show&nbsp;</FormLabel>
                                        <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                            onChange={handlePageSizeChange} className="form-control">
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={30}>30</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                        </select>&nbsp;
                                        <FormLabel>entries</FormLabel>
                                    </div>
                                    <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                                </div>
                                {/* <div className="mt-3">
                                    <MyPagination totalPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                                </div> */}
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container >
            <Payment show={showRecipt} trData={trData}
                onHide={() => setShowRecipt(false)} />
        </>
    )
}
